import { MouseEventHandler } from 'react';
import { useParams } from 'react-router-dom';

import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from '@mui/material';
import { useAppDispatch } from 'app/hooks';
import { fetchIdentitiesById } from 'common/services/api/Identities/Identities.thunk';

import { UserProfileTableHeaderInlineStyles } from '../UserProfileEntityContainerTypeDefs';

import { CreateButton } from './CreateButton';
import { UserProfileEntityTableWrapper } from './UserProfileEntityTableWrapper';

type ProfileBarProps = {
    title: string;
    createButtonName: string;
    createButtonOnClick?: MouseEventHandler<HTMLButtonElement>;
    shouldShowCreateButton?: boolean;
    isCreateButtonDisabled?: boolean;
    useTitleInfoIcon?: boolean;
    iconTooltipText?: string;
    testId?: string;
    profileBarHeaderInlineStyles?: UserProfileTableHeaderInlineStyles;
    includeRefreshButton?: boolean;
};

export function ProfileBar({
    title,
    createButtonName,
    createButtonOnClick,
    shouldShowCreateButton,
    isCreateButtonDisabled,
    useTitleInfoIcon,
    iconTooltipText,
    testId,
    profileBarHeaderInlineStyles,
    includeRefreshButton
}: Readonly<ProfileBarProps>) {
    const dispatch = useAppDispatch();
    const { userId = '' } = useParams();

    const handleRefresh = () => {
        dispatch(fetchIdentitiesById({ userId, noCache: true }));
    };

    return (
        <UserProfileEntityTableWrapper
            title={title}
            useTitleInfoIcon={useTitleInfoIcon}
            iconTooltipText={iconTooltipText}
            tableHeaderInlineStyles={profileBarHeaderInlineStyles}
        >
            {includeRefreshButton &&
                <IconButton
                    sx={{
                        fontFamily: ['Source Sans Pro'].join(','),
                        WebkitFontSmoothing: 'auto',
                        letterSpacing: 'normal',
                        fontSize: 16,
                        color: 'primary.accent',
                    }}
                    data-testid={'testId'}
                    onClick={handleRefresh}
                    aria-label="refresh"
                >
                    <RefreshIcon />
                </IconButton>
            }
            {shouldShowCreateButton &&
                <CreateButton
                    onClickHandler={createButtonOnClick}
                    buttonName={createButtonName}
                    disabled={isCreateButtonDisabled}
                    testId={testId}
                />
            }
        </UserProfileEntityTableWrapper>
    );
}
